import getTarget from '../utils/get-target';

// Add/remove bookmark button
document.addEventListener('click', (event) => {
  const $target = getTarget(event.target, '.js-toggle-panorama');

  // Check if item was clicked
  if ($target) {
    document.querySelectorAll('.panorama').forEach(($el) => {
      let $frame = $el.children[0];
      $el.classList.add('panorama--show');

      console.log($frame.getAttribute('src'));
      if (!$frame.hasAttribute('src') || $frame.getAttribute('src') === '') {
        $frame.setAttribute('src', $frame.getAttribute('data-src'));
      }

      // Disable focus catch by click
      $el.addEventListener('click', function () {
        this.classList.remove('panorama--show');
      });
    });
  }
});
